export const allArticles = [
  {
    id: 1,
    title: '黄瓜视频App最新版本下载安装完整教程（2026年）',
    excerpt: '本文详细介绍黄瓜视频App在iOS和Android平台的最新版本下载与安装步骤，附带常见安装问题解决方案，助您3分钟内成功安装。',
    category: '下载教程',
    categorySlug: 'xiazai-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20vibrant%20short%20video%20app%20interface%20with%20colorful%20content%20feed%2C%20clean%20minimal%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%20style%2C%20bright%20and%20energetic%20aestheticwith%20fresh%20green%20accents&width=800&height=450&seq=article-cover-1&orientation=landscape',
    date: '2026-08-01',
    readTime: '8分钟',
    featured: true,
    content: `黄瓜视频App作为当前最受欢迎的短视频平台之一，拥有海量优质内容和流畅的观看体验。本文将为您提供最新版本的详细下载与安装教程。

## iOS设备下载安装步骤

1. 打开您iPhone上的 **App Store**
2. 点击右下角"搜索"标签
3. 在搜索栏输入"黄瓜视频"
4. 找到官方应用（开发者：黄瓜视频科技有限公司）
5. 点击"获取"按钮，使用Face ID/Touch ID或Apple ID密码确认下载
6. 下载完成后自动安装，桌面将出现黄瓜视频图标
7. 打开App，按照引导完成初始设置即可

> **温馨提示：** 请确保iOS系统版本在13.0以上，设备剩余存储空间大于500MB。

## Android设备下载安装步骤

### 方式一：应用市场下载（推荐）
1. 打开手机自带的应用市场（华为应用市场/小米应用商店/OPPO软件商店等）
2. 搜索"黄瓜视频"
3. 找到官方应用并点击"安装"
4. 等待下载和自动安装完成

### 方式二：官方网站下载APK
1. 使用手机浏览器访问黄瓜视频官方网站
2. 点击首页"Android下载"按钮
3. 下载APK安装包文件
4. 下载完成后点击通知栏中的下载文件，或进入文件管理器找到APK文件
5. 如系统提示"未知来源"，请前往"设置-安全"中开启"允许安装未知来源应用"
6. 点击安装，等待完成即可

> **注意：** 请务必从官方渠道下载，避免下载到恶意篡改的安装包。安装前请确保手机剩余存储空间大于1GB。

## 常见安装问题及解决方案

**Q: iOS下载时提示"无法下载App"**
A: 请检查网络连接，尝试切换WiFi或蜂窝数据；如仍无法下载，可尝试重启手机后重试。

**Q: Android安装时提示"解析包错误"**
A: 说明下载的APK文件不完整，请删除后重新下载；同时确认Android系统版本在8.0以上。

**Q: 安装后打开闪退**
A: 尝试清除App缓存数据，或卸载后重新安装最新版本。`,
  },
  {
    id: 2,
    title: '黄瓜视频App十大隐藏功能，90%的用户都不知道',
    excerpt: '从手势快捷操作到智能省流模式，揭秘黄瓜视频App那些鲜为人知的实用功能，让你的使用体验再上一个台阶。',
    category: '使用技巧',
    categorySlug: 'shiyong-jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20with%20glowing%20app%20icons%20and%20hidden%20feature%20hints%20floating%20around%20it%2C%20mysterious%20and%20techy%20vibe%2C%20dark%20background%20with%20green%20glow%20accents%2C%20digital%20illustration%20style%2C%20clean%20composition&width=800&height=450&seq=article-cover-2&orientation=landscape',
    date: '2026-07-28',
    readTime: '12分钟',
    featured: true,
    content: `黄瓜视频App除了基本的视频浏览功能，还藏着许多不为人知的实用技巧。今天就来为大家揭秘十大隐藏功能。

## 1. 双击快速点赞
在视频播放页面任意位置双击屏幕，即可一键点赞，无需寻找点赞按钮。

## 2. 长按倍速播放
长按视频画面，视频将以2倍速播放，松开后恢复原速。刷到不感兴趣但想看完的内容时特别实用。

## 3. 右滑进入作者主页
在视频播放页面向右滑动，即可直接进入当前视频作者的主页，查看ta的全部作品。

## 4. 三指下滑快速截屏
三根手指同时向下滑动可以快速截取当前视频画面，截屏会自动保存到相册。

## 5. 音量键翻页
在"设置-播放设置"中开启"音量键翻页"功能后，可以使用手机实体音量键上下切换视频。

## 6. 智能省流模式
在"设置-通用"中开启智能省流模式，App会根据网络状况自动调整视频清晰度，帮你节省移动数据流量。

## 7. 定时关闭
睡前刷视频怕睡着？在播放页点击"更多-定时关闭"，可以设置15/30/60分钟后自动暂停播放。

## 8. 私密收藏夹
在收藏页面长按任意收藏夹，选择"设为私密"，可以创建只有自己可见的私密收藏夹。

## 9. 弹幕屏蔽关键词
在视频弹幕设置中，可以添加自定义屏蔽关键词，过滤掉不想看到的弹幕内容。

## 10. 多设备无缝切换
使用同一账号登录不同设备，观看历史和收藏内容会自动同步，随时随地接着看。

掌握以上十个隐藏功能，相信你的黄瓜视频使用体验会有质的飞跃！`,
  },
  {
    id: 3,
    title: '新手必看：黄瓜视频App从注册到发布第一条视频全流程',
    excerpt: '面向零基础新用户的完整入门指南，涵盖账号注册、个人资料设置、内容浏览、视频拍摄与发布的每一个步骤。',
    category: '使用技巧',
    categorySlug: 'shiyong-jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beginner%20friendly%20smartphone%20screen%20showing%20a%20step%20by%20step%20registration%20process%20for%20a%20video%20app%2C%20warm%20inviting%20colors%2C%20clean%20interface%20design%2C%20soft%20natural%20lighting%2C%20friendly%20and%20approachable%20aesthetic&width=800&height=450&seq=article-cover-3&orientation=landscape',
    date: '2026-07-25',
    readTime: '10分钟',
    featured: false,
    content: `刚下载黄瓜视频App不知道从哪里开始？别担心，这篇文章带你从零开始，一步步成为短视频达人！

## 第一步：注册账号
打开App后，你有三种注册方式：
- 手机号注册：输入手机号，获取验证码，设置密码即可
- 微信登录：一键授权，最快捷的方式
- Apple ID登录（仅iOS）：安全便捷

注册完成后，系统会引导你选择感兴趣的内容领域，帮助算法更好地为你推荐内容。

## 第二步：设置个人资料
点击底部"我的"-"编辑资料"：
- 上传头像（建议使用本人照片，增加可信度）
- 设置昵称（2-12个字符，支持中文、字母、数字）
- 填写个人简介（最多100字，让别人了解你）
- 选择性别和地区

## 第三步：浏览内容
在"首页"标签页，你会看到系统推荐的内容流：
- 上下滑动切换视频
- 双击点赞，点击评论图标发表评论
- 点击分享按钮，可分享到微信、朋友圈等平台
- 长按不喜欢的视频，选择"不感兴趣"，优化推荐

## 第四步：关注创作者
遇到喜欢的创作者，点击头像旁的"关注"按钮，ta的新作品会优先出现在你的首页。

## 第五步：拍摄与发布你的第一条视频
1. 点击底部中央的"+"发布按钮
2. 选择拍摄时长（15秒/60秒/3分钟）
3. 点击红色录制按钮开始拍摄，再次点击暂停
4. 拍摄完成后进入编辑页面，可以添加滤镜、音乐、特效、文字
5. 编辑完成后点击"下一步"
6. 填写视频描述、添加话题标签
7. 设置封面（可从视频中选择或上传自定义封面）
8. 点击"发布"，大功告成！

恭喜你，现在已经完全掌握了黄瓜视频App的基础使用！接下来就可以尽情探索短视频的精彩世界了。`,
  },
  {
    id: 4,
    title: '黄瓜视频App安卓版无法安装？六种解决方案汇总',
    excerpt: '针对安卓用户常见的安装失败、解析包错误、空间不足等问题，提供六种经过验证的解决方案，总有一种适合你。',
    category: '常见问题',
    categorySlug: 'changjian-wenti',
    coverImage: 'https://readdy.ai/api/search-image?query=Android%20phone%20screen%20showing%20an%20app%20installation%20error%20message%20with%20a%20troubleshooting%20guide%20overlay%2C%20tech%20support%20concept%2C%20clean%20modern%20design%2C%20warm%20amber%20and%20green%20color%20scheme&width=800&height=450&seq=article-cover-4&orientation=landscape',
    date: '2026-07-20',
    readTime: '6分钟',
    featured: false,
    content: `安卓手机在安装黄瓜视频App时可能会遇到各种问题，本文汇总了最常见的六种情况及其解决方案。

## 问题一：提示"解析包错误"
**原因：** APK文件下载不完整或与系统不兼容
**解决：** 删除已下载的APK文件，从官方网站重新下载。确保下载过程中网络稳定，不要中断。

## 问题二：提示"存储空间不足"
**原因：** 手机剩余空间小于安装包所需
**解决：** 清理手机缓存和垃圾文件，删除不常用的应用，确保剩余空间至少2GB以上。

## 问题三：提示"未知来源被禁止"
**原因：** Android安全设置阻止了非应用市场来源的安装
**解决：** 进入"设置-安全/隐私-特殊应用权限-安装未知应用"，找到使用的浏览器，开启"允许来自此来源的应用"。

## 问题四：安装进度条不动
**原因：** 手机内存不足或后台进程过多
**解决：** 关闭后台不用的应用，重启手机后再次尝试安装。

## 问题五：安装后应用无法打开
**原因：** 系统版本过低或存在兼容性问题
**解决：** 确认Android系统版本在8.0以上。如版本符合要求，尝试清除应用数据或卸载重装。

## 问题六：提示"应用未安装"
**原因：** 手机已存在同名应用但签名不一致
**解决：** 先完全卸载旧版本的黄瓜视频App，再安装新版本。不要使用"覆盖安装"的方式。

如果以上方法均未能解决您的问题，请通过App内的"帮助与反馈"联系技术支持团队。`,
  },
  {
    id: 5,
    title: '黄瓜视频App v5.8.0版本更新：全新界面与AI创作助手上线',
    excerpt: '最新版本带来了全面焕新的UI设计、AI智能剪辑助手、画质增强引擎等重磅功能，详细解读本次更新的所有亮点。',
    category: '版本更新',
    categorySlug: 'xinban-gengxin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20freshly%20updated%20modern%20video%20app%20interface%20with%20AI%20features%20highlighted%2C%20futuristic%20yet%20warm%20design%2C%20clean%20white%20background%20with%20green%20and%20orange%20accent%20elements%2C%20product%20showcase%20style&width=800&height=450&seq=article-cover-5&orientation=landscape',
    date: '2026-07-15',
    readTime: '7分钟',
    featured: false,
    content: `黄瓜视频App v5.8.0版本已正式发布！本次更新带来了多项重磅功能，让我们一起来看看有哪些值得期待的变化。

## 全新UI设计
本次更新对整体界面进行了全面焕新：
- 采用更现代简约的设计语言
- 优化了信息层级，核心内容更突出
- 新增深色模式自动切换
- 图标系统全面升级，更加清晰直观

## AI智能剪辑助手
这是本次更新最大的亮点：
- AI自动识别精彩片段，一键生成精彩集锦
- 智能配乐：根据视频内容自动匹配合适的背景音乐
- 智能字幕：语音自动转字幕，支持中英文
- 智能调色：一键优化视频色彩

## 画质增强引擎
- 支持1080P/2K高清拍摄
- AI超分辨率技术，低画质视频智能增强
- HDR效果优化，画面更生动

## 其他优化
- 播放器性能提升，加载速度加快30%
- 评论互动更加流畅
- 修复了若干已知问题

快去更新体验新版本吧！如果有任何问题或建议，欢迎在评论区留言讨论。`,
  },
  {
    id: 6,
    title: '黄瓜视频App隐私设置详解：保护你的个人信息安全',
    excerpt: '全面解析黄瓜视频App的隐私保护机制，教你如何正确设置账号隐私、管理数据权限、开启安全防护，让使用更安心。',
    category: '安全隐私',
    categorySlug: 'anquan-yinsi',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20privacy%20protection%20shield%20icon%20with%20lock%20symbol%2C%20digital%20security%20concept%2C%20clean%20professional%20design%2C%20soft%20green%20gradient%20background%2C%20trustworthy%20and%20reliable%20aesthetic&width=800&height=450&seq=article-cover-6&orientation=landscape',
    date: '2026-07-10',
    readTime: '9分钟',
    featured: false,
    content: `在数字时代，个人隐私安全越来越受到关注。黄瓜视频App提供了完善的隐私保护功能，本文将详细介绍如何正确配置。

## 账号隐私设置
进入"我的-设置-隐私设置"，你可以：
- 设置谁可以给你发私信（所有人/我关注的人/关闭）
- 设置谁可以查看你的喜欢列表
- 设置谁可以在视频中@你
- 开启/关闭"推荐给可能认识的人"

## 位置隐私
- 发布视频时可选择是否添加位置信息
- 在系统设置中可关闭App的位置权限
- 即使授权位置，App也不会在后台持续获取

## 数据权限管理
- 相册权限：仅在发布内容时需要
- 麦克风权限：仅在录制视频时使用
- 通讯录权限：可选择不授权，不影响正常使用
- 可在手机系统设置中随时修改各项权限

## 青少年保护
- 开启青少年模式后，每日使用时长受限
- 自动过滤不适宜内容
- 关闭打赏和充值功能
- 晚上22:00至次日6:00无法使用

## 数据安全
- 采用HTTPS加密传输
- 用户密码使用不可逆加密存储
- 通过国家信息安全等级保护认证
- 定期进行第三方安全审计

保护好个人隐私，让每一次使用都安心无忧！`,
  },
];